import {
  PMyProfile
} from "libs/raas-ui-react-components/src/components";
import { useEffect, useState } from "react";
import useToast from "hooks/useToast";
import { useNavigate } from "react-router-dom";

import { mapPMyProfile } from "./PrivateHome.util";
import { IUserData, RaaSSession, SessionStorageItems, setStorage, setUserDetail } from "services/user/user.session.service";
import useSession from "hooks/useSession";
import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import { removeItemStorage } from "services/util/sessionStorage.service";
import { getUserData } from "services/user/user-micros.service";
import { useTranslation } from "react-i18next";

import { signOutCognitoUser } from "services/user/user-login-social.service";

export default function PrivateHome() {
  
  const [t] = useTranslation('privateHome');
  const [userData, setUserData] = useState<any>("");
  const [userDetailLocal, setUserDetailLocal] = useState(null);
  const { logged, loggedSocial, setSession, setLogged, setUserConnected } = useSession();
  const { openToast } = useToast();
  const navigate = useNavigate();
  let lenguage = "";

  useEffect(() => {
    !!sessionStorage.getItem('current-page') && sessionStorage.removeItem('current-page');
  }, [])

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('raas-language') != lenguage) {
      lenguage = sessionStorage.getItem('raas-language') as any
      setUserData(mapPMyProfile(userDetailLocal as any, t));
    }

  }, [t]);

  // Public

  const logoutClick = () => {
    if (loggedSocial) {
      signOutCognitoUser();
    } else {
      setLogged(false);
      setSession({} as RaaSSession);
      setUserConnected({} as IUserData);
      removeItemStorage(SessionStorageItems.RAAS_USER);
      removeItemStorage(SessionStorageItems.RAAS_USER_DETAIL);
      setStorage();
      navigate("/login");
    }

  }

  const getData = () => {

    getUserData((response: any) => {
      const userDataResponse = response?.data;
      setUserDetail(userDataResponse)
      setUserDetailLocal(userDataResponse)
      setUserData(mapPMyProfile(userDataResponse, t));
      setUserConnected(userDataResponse);
    }, () => {
      openToast("error", t("literals.error"), t("literals.errorTryAgainLater"));
      logoutClick();
    })
  };


  return (
    <>
      {
        userData && (
          <>
            <PMyProfile
              literals={JSON.stringify(userData)}
              onPMyProfileNavigateToEvent={(e) => navigate(e.detail)}
              onPMyProfileLogoutEvent={() => logoutClick()}
            ></PMyProfile>
            <PrivatePagesWrapper></PrivatePagesWrapper>
          </>
        )
      }
    </>
  );
}
